import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";
import {
  type SortableItemWithId,
  SortableList,
} from "../../../core/components/SortableList";
import { Box } from "../../../ui/Box";
import { Button } from "../../../ui/Button";
import { Label } from "../../../ui/Label";
import type { BusinessModuleType } from "../../modules/types";
import { BusinessAddCardSheet } from "../../modules/ui/BusinessAddCardSheet";
import { TemplateStepDataModuleUI } from "./TemplateStepDataModuleUI";
import type { BusinessModuleTemplateData } from "./types";

export const BusinessAdminTemplateTasks = observer(
  ({
    title,
    businessModules,
    overrideTypes,
    onSave,
    onDelete,
    onEdit,
    onOrderChange,
  }: {
    title: string;
    businessModules: BusinessModuleTemplateData[];
    overrideTypes?: BusinessModuleType[];
    onSave: (
      moduleData: Omit<BusinessModuleTemplateData, "uid">,
    ) => Promise<void>;
    onDelete: (moduleData: BusinessModuleTemplateData) => Promise<void>;
    onEdit: (moduleData: BusinessModuleTemplateData) => void;
    onOrderChange: (modules: BusinessModuleTemplateData[]) => void;
  }) => {
    const [showAddStep, setShowAddStep] = React.useState(false);

    const renderItem = useCallback(
      (listItem: SortableItemWithId<BusinessModuleTemplateData>) => {
        const templateModule = listItem.item;

        return (
          <TemplateStepDataModuleUI
            key={templateModule.uid}
            templateModule={templateModule}
            onDelete={onDelete}
            onEdit={onEdit}
          />
        );
      },
      [onDelete, onEdit],
    );

    return (
      <>
        <Box>
          <Label>{title}</Label>
          <SortableList
            items={businessModules}
            onChange={(items) => {
              onOrderChange(items.map((i) => i.item));
            }}
            renderItem={renderItem}
          />
        </Box>

        <Button
          onPress={() => {
            setShowAddStep(true);
          }}
        >
          Add step
        </Button>
        <BusinessAddCardSheet
          onOpenChange={() => setShowAddStep(false)}
          open={showAddStep}
          sheetId={"businesss-add"}
          overrideTypes={overrideTypes}
          onSave={onSave}
        />
      </>
    );
  },
);
